/**
 * @typedef {import('./betbuilder-market-model').default} BetBuilderMarketModel
 */
export default class BetBuilderTab {
    /**
     * class constructor method
     * @param data
     */
    constructor(data) {
        /**
         * The numerical value of the category
         * @type {number}
         */
        this.tabId = data.Category;
        /**
         * The translated textual value of the category
         * @type {string}
         */
        this.tabName = data.CategoryLocal;
        /**
         * List of BetBuilder markets
         * @type {BetBuilderMarketModel[]}
         */
        this.markets = [];
    }
}
